import { FC, useRef, useState } from 'react';
import * as React from 'react';
import ContentEditable from 'react-contenteditable';
import tw, { css } from 'twin.macro';
import 'styled-components/macro';

import { OutlineBadge } from '../../atoms/badge/Badge';
import { TagType } from './Tags';

export interface AddTagProps {
  onAdd: (tag: TagType) => void;
}

export const AddTag: FC<AddTagProps> = ({ onAdd, ...props }) => {
  const [editing, setEditing] = useState(false);
  const html = useRef('Add tag +');
  const contentEditable = useRef(undefined);

  const startEditing = () => {
    setEditing(true);
    html.current = '';
  };

  const stopEditing = () => {
    setEditing(false);
    html.current = 'Add tag +';
  };

  return (
    <OutlineBadge
      onAction={(e: React.MouseEvent<HTMLDivElement> | React.KeyboardEvent<HTMLDivElement>) => {
        if (e.type === 'keydown') {
          const el = (e.target as HTMLDivElement).querySelector('[contenteditable]');
          el && (el as HTMLElement).focus();
          e.preventDefault();
        }
      }}
      tw="px-0"
      css={
        editing &&
        css`
          box-shadow: 0 0 0 1px currentColor inset;
          ${tw`text-primary-dark`}
        `
      }
      {...props}
    >
      <ContentEditable
        html={html.current}
        innerRef={contentEditable.current}
        onBlur={stopEditing}
        onChange={e => {
          html.current = e.target.value;
        }}
        onFocus={startEditing}
        onKeyDown={e => {
          if (['Enter', 'Escape'].includes(e.key)) {
            e.preventDefault();
            const el = e.target as HTMLInputElement;
            el.blur();
            if (e.key !== 'Escape') {
              const value = (el.textContent as string).trim();
              if (value.length) {
                onAdd({ value });
              }
            }
          }
        }}
        tw="w-full px-1 outline-none"
        css={{ minWidth: 75 }}
      ></ContentEditable>
    </OutlineBadge>
  );
};
